import { render, staticRenderFns } from "./UploadMyData.vue?vue&type=template&id=12d4ed21"
import script from "./UploadMyData.vue?vue&type=script&lang=js"
export * from "./UploadMyData.vue?vue&type=script&lang=js"
import style0 from "./UploadMyData.vue?vue&type=style&index=0&id=12d4ed21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports